import {Component, OnInit, ViewContainerRef, viewChild} from '@angular/core';
import {Modal} from '../../modal';
import { showHide } from '../../modal-animations';

@Component({
    selector: 'app-modal-template-large',
    templateUrl: './modal-template-large.component.html',
    styleUrls: ['./modal-template-large.component.scss'],
    animations: [showHide],
    standalone: true
})
export class ModalTemplateLargeComponent  extends Modal implements OnInit {

  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
